Kubrick.Accordian = {
  _selector: ".accordianstep:not(.ready), .faq:not(.ready)",
  _topSelector: ".top, .question",
  _toggleSelector: ".accordianstep, .faq",

  _controllers: [],
  _configs: [],

  start: function(config) {
    Kubrick._log("Accordian: Configuring...", config);
    this._setupAccordian(document.querySelector("#content ." + config.id));
    this._configs.push(config);
  },

  _setupAccordian: function($BLOCK) {
    var controller = {
      $BLOCK: $BLOCK,
      $STEPS: $BLOCK.querySelectorAll(this._selector)
    };
    if (controller.$STEPS) {
      for (let i = 0; i < controller.$STEPS.length; i++) {
        let $STEP = controller.$STEPS[i];
        this.setupStep($STEP);
      }
      this._controllers.push(controller);
    }
  },

  setupStep: function($STEP) {
    let click_area = $STEP.querySelector(this._topSelector);
    click_area.addEventListener("click", this._expandStep);
    $STEP.classList.add("ready");
    Kubrick._log("Accordian: Set-up", $STEP);
  },

  _expandStep: function(e) {
    let content = e.target.closest(Kubrick.Accordian._toggleSelector);
    if (content) {
      content.classList.toggle("closed");
      var target = content.querySelector(".answer, .content");
      var fromTo = content.classList.contains("closed")
        ? [target.scrollHeight, 0]
        : [0, target.scrollHeight];
      anime({
        targets: target,
        height: fromTo,
        duration: 350,
        easing: "easeInOutQuad"
      });
    }
  }
};
